import { createRequestClient } from '@/utils/request';
import { clearSession, getToken } from '@/utils/storage';

let unauthorizedHandler = () => {};

const request = createRequestClient({
  tokenProvider: getToken,
  onUnauthorized: () => {
    clearSession();
    unauthorizedHandler();
  }
});

export function setUnauthorizedHandler(handler) {
  unauthorizedHandler = typeof handler === 'function' ? handler : () => {};
}

export default request;
